<template>
  <el-dialog custom-class="list-dialog" title="选择类别" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <el-row>
    <el-col :span="4">
      <div class="grid-content bg-purple treeContent">
        <CommonTreeView
          ref="treeSeed" :defineDataSource="true" @bindData="bindData"
          :onlyShowGroupType="true"
          @check="checktree1"
          :needTopNode="false">
        </CommonTreeView>
      </div>
    </el-col>
    <el-col :span="20">
      <div class="grid-content bg-purple-light">
        <!--<div>-->
        <div class="search-content" >
          <el-col :span="24" class="toobar">
            <el-input style="width:200px;"
                      placeholder="请输入分类名称"
                      prefix-icon="el-icon-search"
                      v-model="searchdata">
            </el-input>
            <el-button type="primary" v-model="searchdata" icon="el-icon-search" @click="bindGrid(guids)">搜索</el-button>
            <el-button type="warning" v-on:click="SelectOK" v-if="isShowCheckBox">确定选择</el-button>
            <JxcgoodscategoryEdit ref="DataContactEdit" :guid="guids" :name="this.name" @bindGrid="bindGrid"></JxcgoodscategoryEdit>
          </el-col>
        </div>
        <el-table
          :data="tableData" ref="table1"
          :height="tableHeight(56)"
          size="mini" @selection-change="handleSelectionChange"
          stripe
          border
          style="width: 100%;">
          <el-table-column
            type="index"
            width="60"
            label="序号"
            align="center">
          </el-table-column>
          <el-table-column
            prop="codeandname"
            label="分类名称"
            align="left"
            header-align="center">
          </el-table-column>
          <el-table-column
            prop="sortnum"
            label="排序号"
            align="center"
            header-align="center"
            width="140">
          </el-table-column>
          <el-table-column v-if="isShowCheckBox"
                           type="selection" align="right"
                           width="70">
          </el-table-column>
          <el-table-column v-if="!isShowCheckBox"
                           label="操作"
                           align="center" width="80">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="warning"
                @click="handleSel(scope.$index, scope.row)">选择
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-col>
  </el-row>
  </el-dialog>
</template>
<script>
  import JxcgoodscategoryEdit from './JxcgoodscategoryEdit';
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import {getListData, deleteData,getjdTree} from '@/api/set/jxcgoodscategory'

  var test = require('@/api/set/dept');


  export default {
    name: 'HelloWorld',
    data() {
      return {
        seen: false,
        dialogFormVisible: false,
        SelectionChange: [],
        searchdata: "",
        loading: true,
        guids:{
          categoryname:'',
          categorycode:'',
        },
        gl:"",
        name:'',
        tableData: []
      }
    },
    props: {
      isShowCheckBox: {//true表示多选
        default: false
      }
    },
    methods: {
      checktree1(guids, names, arr) {
        this.gl = guids;
        this.bindGrid(guids);
        this.guids["categoryname"] = names;
        this.guids["categorycode"] = guids;
      },
      show() {
        if (this.isShowCheckBox&&this.$refs.table1) {
          this.$refs.table1.clearSelection()
        }
        this.dialogFormVisible = true
        if (this.tableData.length == 0) {
          this.bindGrid()
        }
      },
      handleEdit(index, row) {
        this.$refs.DataContactEdit.initData(row.categorycode)
        this.OpenDialog();
      },
      handleDelete(index, row) {
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteData({categorycode: row.categorycode}).then(response => {
            this.bindGrid();
            if (response.data.code == 0) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            } else {
              this.$message({
                type: 'error',
                message: response.data.msg
              });
            }

          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      handleSel(index, row) {//单选
        this.$emit("afterSelectCode", row)
        this.dialogFormVisible = false
      },
      SelectOK() {//多选
        this.$emit("afterSelectCode", this.SelectionChange)
        this.dialogFormVisible = false;
      },
      bindGrid() {
        var row = {
          categoryname: this.searchdata,
          categorycode: this.gl,
          enabled: 1
        };
        if (this.gl && this.gl.length == 3) {
          row["allcat"] = "9";
        }
        getListData(row).then(response => {
          this.tableData = response.data.obj.rows
        }).catch((error) => {
          console.log(error)
        });
      },
      handleSelectionChange(val) {
        this.SelectionChange = val;
      },
      OpenDialog() {
        this.$refs.DataContactEdit.show()
      },
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({onlyShowGroupType:true})
        })
      }
    },
    mounted() {
    },
    components: {
      JxcgoodscategoryEdit
    }
  }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/set/jxcgoodscategory/JxcgoodscategorySel.vue